// src/products/products.ts
var Product = /* @__PURE__ */ ((Product2) => {
  Product2["NodeApi"] = "node-api";
  Product2["NftApi"] = "nft-api";
  Product2["BlockTimestampApi"] = "block-timestamp-api";
  Product2["TokenApi"] = "token-api";
  Product2["TransfersApi"] = "transfers-api";
  Product2["BundlerApi"] = "bundler-api";
  Product2["DebugApi"] = "debug-api";
  Product2["EmbeddedAccounts"] = "embedded-accounts";
  Product2["GasManagerApi"] = "gas-manager-api";
  Product2["TraceApi"] = "trace-api";
  Product2["PricesApi"] = "prices-api";
  Product2["Subgraphs"] = "subgraphs";
  Product2["TransactionSimulationApi"] = "transaction-simulation-api";
  Product2["TransactionReceiptsApi"] = "transaction-receipts-api";
  Product2["UserOperationsApi"] = "user-operations-api";
  Product2["Websockets"] = "smart-websockets";
  Product2["Webhooks"] = "webhooks";
  return Product2;
})(Product || {});

export {
  Product
};
//# sourceMappingURL=chunk-UVWGGWCY.mjs.map